import * as React from "react"
import { Link, StaticQuery } from "gatsby"
import { graphql } from 'gatsby'

import Sidebar from '.././components/sidebar'
import Header from '.././components/header'

const Layout = ({ title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  //const isRootPath = location.pathname === rootPath
  let header = (
      <Header></Header>
    )


  return (
    <StaticQuery
      query={graphql`
        query LayoutQuery {
          allFile(filter: { extension: { regex: "/(jpg|jpeg|png|gif)/" } }) {
            edges {
              node {
                relativePath
                childImageSharp {
                  gatsbyImageData(width: 256)
                }
              }
            }
          },
          site {
            siteMetadata {
              author {
                name
                summary
                social {
                  twitter
                  linkedin
                  github
                }
              }
              features {
                name
                description
                img
                link
                alt
              }
              description
            }
          }
        }
      `}
      render={ data => (
        <div className="global-wrapper">
          {/* HEADER */}
          {header}
          <div className="container-fluid marketing">

            <div className="row featurette">
              <div className="col-12 col-sm-12 col-md-10 offset-md-1 margin-header">
                <div className="row">
                  {/* MAIN */}
                  <div className="col-12 col-sm-8 col-md-8">
                    <main>{children}</main>
                  </div>
                  {/* MARGIN */}
                  <div className="col-0 col-sm-1 col-md-2">
                  </div>
                  {/* SIDE BAR */}
                  <Sidebar />
                </div>
              </div>
            </div>
            {/* FOOTER */}
            <hr className="divider"/>
            <footer className="mb-3">
              <div className="row gap-3 gap-md-0 mb-2 mb-md-0">
                <div className="col-12 col-md-4 order-3 order-md-1">
                © 2008-{new Date().getFullYear()} <Link to="/about">{data.site.siteMetadata.author.name}</Link>, Powered by
                  {` `}
                  <a href="https://www.gatsbyjs.com">Gatsby</a>
                </div>
                <div className="col-7 col-md-4 order-1 order-md-2">
                  <div className="d-flex justify-content-around">
                    <a href={`https://twitter.com/${data.site.siteMetadata.author.social.twitter}`} className="twitter-follow-button" data-show-count="true" data-size="large">Follow @{data.site.siteMetadata.author.social.twitter}</a>
                    <span><a href="/rss.xml"><img src="/social/rss.png" alt="abonnez vous aux flux RSS du site !" className="rss" width="25" height="25"/></a></span>
                  </div>
                </div>
                <div className="col-4 col-md-2 ms-auto order-2 order-md-3">
                  <a href="#">Back to top</a>
                </div>
              </div>
            </footer>
          </div>
        </div>

    )}
    />
  )
}

export default Layout
